module.exports = __webpack_public_path__ + "static/img/icon-p1.c4ee3f79.png";